import script from "./OrderTimer.vue?vue&type=script&setup=true&lang=ts"
export * from "./OrderTimer.vue?vue&type=script&setup=true&lang=ts"

import "./OrderTimer.vue?vue&type=style&index=0&id=af7b5ff8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-af7b5ff8"]])

export default __exports__